
export const CORE_ASSESSMENT_NAMES = ['PHQ9', 'GAD7', 'CD-RISC2', 'STRESS', 'ENERGY'];
